import {
  IInstitution,
  IError,
  IQueryHookOptions,
  IUpdateInstitutionRequest,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { addInstitution, updateInstitution } from 'services';

type UpdateInstitutionFunction = UseMutateAsyncFunction<
  IInstitution,
  unknown,
  IUpdateInstitutionRequest
>;

type UseUpdateInstitution = [UpdateInstitutionFunction, IQueryHookOptions];

export const useUpdateInstitution = (
  institutionId = '',
): UseUpdateInstitution => {
  const queryClient = useQueryClient();
  const { error, isError, isLoading, mutateAsync } = useMutation<
    IInstitution,
    IError,
    IUpdateInstitutionRequest
  >(
    (values: IUpdateInstitutionRequest) => {
      if (institutionId === '') {
        return addInstitution(values);
      }
      return updateInstitution(institutionId, values);
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData(['institutions', institutionId], data);
        queryClient.invalidateQueries(['institutions']);
      },
    },
  );

  return [mutateAsync, { error, isError, isLoading }];
};
